import { type InteractionTab } from '../types/FeedInteractionFields';
import { getCurrentNavTab } from './getNavTabFromPathname';

/**
 * Exp 242 requires `tab` on every product/pairing action type, but PDP/RDP
 * actions fire from surfaces that don't know their tab — cart mutations and the
 * order detail page. Fall back to the current route so those callers don't have
 * to thread it through, mirroring Android's `resolveTab`: a caller with richer
 * context still wins, and off-tab routes stay omitted (not null) so non-nav
 * surfaces keep their existing payload shape.
 *
 * Deliberately not folded into `buildFeedInteractionPayload` — that stays a pure
 * mapper, and `cookbookInteraction` uses it while relying on an explicit `tab`.
 */
export function resolveInteractionTab(
  tab: InteractionTab | undefined
): InteractionTab | undefined {
  return tab ?? getCurrentNavTab() ?? undefined;
}
